import { useLocation } from "react-router-dom";
import { Logo } from "../Logo";

import NavButton from "../NavButton";
import NavLink from "../NavLink";
import styles from "./styles.module.css";

export default function Header() {
  const { pathname } = useLocation();
  const isOnGiftsPage = pathname === "/gifts";

  return (
    <div className={styles.header}>
      <Logo />
      <div className={styles.right}>
        <input id={styles.menu_toggle} type="checkbox" />
        <label className={styles.menu_btn} htmlFor={styles.menu_toggle} />
        <div className={styles.navlist}>
          <NavLink href={"/durak.apk"}>
            <img width="28" src="download.svg" alt="Скачать" />
            Скачать игру
          </NavLink>
        </div>
        {!isOnGiftsPage && <NavButton to="/gifts">Пополнить фишки</NavButton>}
      </div>
    </div>
  );
}
